module.exports = __webpack_public_path__ + "static/media/google-play-badge.0a4c89f8.png";